enum SurveyStatusEnum {
    Draft = 0,
    Live = 1,
    Closed = 2,
}

export default SurveyStatusEnum;